import { Spinner } from '../ui/Spinner';

/** Holds the space for the sign-in options until Firebase says which are switched on. */
export default function SignInMethodsLoading() {
    return (
        <div className="flex justify-center py-8">
            <Spinner size="lg" decorative={false} aria-label="Loading sign-in options" />
        </div>
    );
}
